import { configureStore } from '@reduxjs/toolkit';
import chatReducer from './chatSlice';
import notificationsReducer from './notificationsSlice';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import sessionReducer from './sessionSlice';
import associateEventsReducer from './associateEventsSlice';

const store = configureStore({
  reducer: {
    chat: chatReducer,
    notifications: notificationsReducer,
    session: sessionReducer,
    associateEvents: associateEventsReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { store };
